<template>
  <AppWrapper>
    <router-view :key="$route.fullPath"/>
  </AppWrapper>
</template>

<script>
/* eslint-disable */
import {mapActions} from "vuex";
import API from "@/plugins/api";
import AppWrapper from "@/components/common/AppWrapper.vue";

export default {
  name: "App",

  components: {
    AppWrapper,
  },

  watch: {
    "$auth.isAuthenticated": async (val) => {
      if (val && this && this.$auth) {
        const token = await this.$auth.getTokenSilently();
        API.setHeaders("Authorization", `Bearer ${token}`);
      }
    },
  },

  created() {
    //- APP startup code
    console.log('[app] App.vue created() – isReady:', API.isReady, 'endpoints:', Object.keys(API.endpointList).length)

    return Promise.all([
      //- API, store
      this.$store.dispatch("init"),
    ])
      .then(
        //- Flag to say we're ready to go
        () => this.setInitialized()
      )
      .catch((error) => {
        console.log("Error in init: ", error);
      });
  },

  methods: {
    ...mapActions("app", ["setInitialized"]),
  },
};
</script>